import { render, staticRenderFns } from "./DashFinanceiro.vue?vue&type=template&id=5ac7a8b9"
import script from "./DashFinanceiro.vue?vue&type=script&lang=js"
export * from "./DashFinanceiro.vue?vue&type=script&lang=js"
import style0 from "./DashFinanceiro.vue?vue&type=style&index=0&id=5ac7a8b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports